"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgPencil(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M16.451.224c.3-.299.784-.299 1.084 0l6.24 6.241c.3.3.3.784 0 1.084L8.798 22.527a.766.766 0 01-.416.214l.035-.009-.021.022-.014-.013L.892 23.99a.766.766 0 01-.881-.881l1.248-7.49-.013-.013.02-.022a.766.766 0 01.207-.38zM2.59 16.95l-.892 5.351 5.35-.893L2.59 16.95zM13.475 5.366L3.324 15.517l5.158 5.158 10.15-10.151-5.157-5.158zm3.517-3.518l-2.434 2.435 5.158 5.158 2.434-2.434-5.158-5.159z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgPencil;
exports.default = _default;